module.exports = __webpack_public_path__ + "static/media/boom_logo.88b451d3.png";